import { setStudioView } from '../workspace/studio-views';
import { Showcase, type ShowcaseProps } from './Showcase';
export function mountShowcase(_host:HTMLElement,props:ShowcaseProps){setStudioView('app','showcase',<Showcase {...props}/>)}
